import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import { createAuth } from '@/plugins/oidc'
import router from '@/router'

import directoryApi from '@/services/directoryApi'
import '@fontsource/quicksand'
import '@mdi/font/css/materialdesignicons.css'

(async () => {
    let response = await fetch(process.env.BASE_URL + 'config.json')
    const config = await response.json()
    const auth = await createAuth(config.oidc)

    auth.useRouter(router)
    Vue.prototype.$auth = auth

    directoryApi.configure(config.apiServer)
    directoryApi.useAuth(auth)
    Vue.prototype.$directoryApi = directoryApi

    new Vue({
        vuetify,
        router,
        render: h => h(App),
    }).$mount('#app')
})()

Vue.config.productionTip = false
